/**
 * OMBRE — traduire l'état de propriété LU SUR LE BUS en ce que l'écran montre.
 *
 * ⛔ Ce n'est PAS un cinquième mode. Les quatre modes (off · manuel · auto ·
 * planifié) sont un RÉGLAGE que l'utilisateur choisit ; l'ombre est un CONSTAT
 * sur qui possède la fonction. Les mélanger donnerait à cliquer sur ce qui ne
 * se règle pas là, et ferait lire « agent mal configuré » là où il faut lire
 * « le handler historique est encore propriétaire ».
 *
 * Fonction PURE et séparée du JSX pour être vérifiable : c'est la traduction
 * état → écran qui doit être prouvée, pas le balisage.
 *
 * L'entrée est le champ `propriete` rendu par `GET /api/hub-ia/agents`, lui-même
 * dérivé des abonnements réels du bus (cf. `backend/hub_ia/propriete.py`).
 */

export const ETAT_AUCUN = "aucun";
export const ETAT_OMBRE = "ombre";
export const ETAT_PROPRIETAIRE = "proprietaire";
export const ETAT_ANOMALIE = "anomalie";

/**
 * @param {object|null|undefined} propriete
 * @returns {{etat: string, libelle: string|null, couleur: string|null, detail: string|null}}
 */
export function etatProprieteAgent(propriete) {
  const rien = { etat: ETAT_AUCUN, libelle: null, couleur: null, detail: null };
  if (!propriete) return rien;

  const evenements = propriete.evenements || {};
  const codes = Object.keys(evenements);

  if (propriete.anomalie) {
    const detail = codes
      .filter((e) => evenements[e] && evenements[e].anomalie)
      .map((e) => `${e} : ${evenements[e].proprietaire || "état illisible"}`)
      .join(" · ");
    return {
      etat: ETAT_ANOMALIE,
      libelle: "propriété anormale",
      couleur: "red",
      detail: detail || null,
    };
  }

  if (propriete.en_ombre) {
    return {
      etat: ETAT_OMBRE,
      libelle: "ombre",
      couleur: "amber",
      detail: null,
    };
  }

  // Aucun événement branché : il n'y a rien à dire sur la propriété, et un
  // badge « propriétaire » y serait faux — l'agent ne reçoit rien.
  if (codes.length === 0) return rien;

  return {
    etat: ETAT_PROPRIETAIRE,
    libelle: "propriétaire",
    couleur: "green",
    detail: null,
  };
}
